import { createAction } from "redux-act";

import { PortalConfiguration } from "./types";

export const portalConfigSet = createAction<PortalConfiguration | null>("portalConfig/portalConfigSet");
